import React, { useEffect, useState } from "react";
import { getFirestore } from "../../config/firebase";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

const WhatsAppFlotante = () => {
  const [mostrarWhatsapp, setMostrarWhatsapp] = useState(false);
  const { openConsultaForm, loading } = useWhatsAppConsulta();

  useEffect(() => {
    const cargarDatosInformacion = async () => {
      const datosLocales = sessionStorage.getItem("fiat-informacion");
      if (datosLocales) {
        const datosCompletos = JSON.parse(datosLocales);
        setMostrarWhatsapp(datosCompletos[1].mostrar);
      } else {
        const db = getFirestore();
        const vehicles = db.collection("fiat-informacion");
        try {
          const querySnapshot = await vehicles.get();
          const datosCompletos = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          setMostrarWhatsapp(datosCompletos[1].mostrar);
          sessionStorage.setItem("fiat-informacion", JSON.stringify(datosCompletos));
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        }
      }
    };

    cargarDatosInformacion();
  }, []);

  if (!mostrarWhatsapp) {
    return null;
  }

  return (
    <div className="whatsapp-container">
      <button className="btn-whatsapp-flotante" onClick={openConsultaForm} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;
